import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import Title from '../Title/Title';
import AboutImg from '../Image/AboutImg';
import PortfolioContext from '../../context/context';

const About = () => {
  const { about } = useContext(PortfolioContext);
  const { img, paragraphOne, paragraphTwo, paragraphThree, resume } = about;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="about">
      <Container>
        <Title title=" <About Me props={Yamin} />" />
        <Row className="about-wrapper">
          <Col md={6} sm={12}>
            <Fade bottom duration={1000} delay={600} distance="30px">
              <div className="about-wrapper__image">
                <AboutImg alt="profile picture" filename={img} />
              </div>
            </Fade>
          </Col>
          <Col md={6} sm={12}>
            <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
              <div className="about-wrapper__info">
                <p className="about-wrapper__info-text">
                  {paragraphOne ||
                    "I'm a polyglot software developer experienced in JavaScript, TypeScript, Python, C#, and Java, known for my dedication, problem-solving skills, and curiosity. I value fresh perspectives and thrive on challenges. I hold a Master's in Information Technology specializing in Software Engineering from RMIT University, Melbourne, with a background in advanced programming, algorithms, and cloud courses"}
                </p>
                <p className="about-wrapper__info-text">
                  {paragraphTwo ||
                    "I have industry experience with React, Next.js, TypeScript, and the ASP.NET framework. I've developed applications using both SQL and NoSQL database systems and have a passion for exploring new development frameworks and tools. Beyond coding, I'm enthusiastic about IoT devices."}
                </p>
                <p className="about-wrapper__info-text">
                  {paragraphThree || 'Lorem ipsum dolor sit, amet consectetur adipisicing elit.'}
                </p>
                {resume && (
                  <span className="d-flex mt-3">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-btn cta-btn--resume"
                      href={
                        'https://drive.google.com/file/d/1_ledEraz0P6h2dAb26NRk7pRnXV8JtC6/view?usp=sharing'
                      }
                    >
                      Resume
                    </a>
                  </span>
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
